import {handleParam} from "./paramsHandler";
import wixLocationFrontend from "wix-location-frontend";
import {setParamInSession} from "./paramsHandler";
import { openLightbox } from "wix-window-frontend";
import { IS_QA_KEY } from "./qa";

const BRANCH_ID_KEY = "branchId";
const SITE_REVISION_VALUE = "2";

export function handleBranchId() {
    const parsedUrl = new URL(wixLocationFrontend.url);
    const isQa = parsedUrl.searchParams.get(IS_QA_KEY);

    const method = (paramKey, paramFromUrl) => {if (isQa) {
        console.log("QA environment detected. Branch ID will be set in session storage without opening the lightbox.");
        setParamInSession(paramKey, paramFromUrl);
    }else{
        openLightbox("preview-version", { branchId: paramFromUrl});
    }}

    return handleParam(BRANCH_ID_KEY, method, { siteRevision: SITE_REVISION_VALUE });
}